<script>
import {cancelarPreretirada, consultaPagamentoBoleto, pagarPreretirada, consultarPix} from '../../../../domain/grv/services'
import moment from 'moment'
import {REAL_BRL} from '../../../../utils/helpers/money'
import {VMoney} from 'v-money'
import {VueMaskDirective as mask} from 'v-mask'
import {
  STATUS_PENDENTE, STATUS_PAGO,
  Status as StatusPreRetirada,
  StatusTitle as StatusTitlePreRetirada
} from '../../../../domain/grv/helpers/PreRetiradaStatus'
import {registraChavePix, alteraStatusParaPendente} from '../../../../domain/pre-retirada/services'
import {FAVORECIDO_DETRO, FAVORECIDO_APL} from '../../../../domain/grv/helpers/pre-retirada-favorecidos'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'
import {STATUS_PIX_COBRANCA_ATIVA, STATUS_PIX_COBRANCA_CONCLUIDA} from '../../../../domain/grv/helpers/pix'

export default {
  mixins: [AclCheckMixins],
  directives: {mask, money: VMoney},
  name: 'grv-consulta-pagamento',
  props: ['preretirada'],
  components: {
    BtnAlteraDataPagamentoPreretirada: () => import('../../grvs/components/grv-patio/BtnAlteraDataPagamentoPreretirada'),
    BtnAlteraPixPagador: () => import('../../grvs/components/grv-patio/BtnAlteraPixPagador')
  },
  data () {
    return {
      money: REAL_BRL,
      referencia: this.preretirada.referencia,
      chavePixPagador: this.preretirada.chavePixPagador,
      confirmarPagamento: false,
      pagamentoProcessado: false,
      pagamentoCancelado: false,
      pagamamento: {
        valor: this.preretirada.valor,
        dataPagamento: moment().format('L')
      },
      confirmarCancelamento: false,
      cancelamento: {
        motivo: null
      },
      emitirRespostaConsultaBoleto: false,
      consultaBoleto: {
        referencia: null,
        naoEncontrado: true,
        pago: false,
        dataPagamento: null,
        mensagemRetorno: null
      },
      FAVORECIDO_DETRO,
      FAVORECIDO_APL,
      STATUS_PAGO,
      STATUS_PENDENTE,
      openAlteraDataPagamento: false,
      alertaConfirmarCancelamento: false,
      statusPix: null,
      descricaoPix: '',
      STATUS_PIX_COBRANCA_ATIVA,
      STATUS_PIX_COBRANCA_CONCLUIDA,
      txid: null
    }
  },
  computed: {
    StatusPreRetirada () {
      return StatusPreRetirada
    }
  },
  mounted () {
    if (this.preretirada && Array.isArray(this.preretirada.pixTransactions)) {
      const ultimaPix = [...this.preretirada.pixTransactions].reverse().find(p => p.txid)
      if (ultimaPix) {
        this.txid = ultimaPix.txid
      }
    }
  },
  destroyed () {
  },
  methods: {
    consultar () {
      console.log('Consulta DETRO', this.preretirada)
      this.$loaderOverlay.open().message('Comunicando com o DETRO')
      this.emitirRespostaConsultaBoleto = false
      consultaPagamentoBoleto(this.referencia)
        .then((response) => {
          this.$loaderOverlay.hide()
          let data = response.data
          this.consultaBoleto = data
          this.emitirRespostaConsultaBoleto = true
          console.log(response, data)
        })
        .catch((response) => {
          alert('Falha ao consultar boleto.')
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    definirPago () {
      this.confirmarPagamento = true
    },
    cancelar () {
      this.alertaConfirmarCancelamento = true
      setTimeout(() => {
        const confirma = confirm(`Cancelar pagamento para esta GRV?`)
        if (!confirma) {
          this.alertaConfirmarCancelamento = false
          return
        }
        let motivo = prompt('Informe o motivo do cancelamento da guia de pré-retirada')
        if (motivo === null) return
        this.confirmarCancelamento = true
        this.$loaderOverlay.open().message('Cancelando Pré-Retirada')
        cancelarPreretirada(this.preretirada.id, motivo)
          .then((response) => {
            this.pagamentoCancelado = true
            this.$loaderOverlay.hide()
            let data = response.data
            console.log(response, data)
            this.$emit('statusPagamentoAlterado')
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }, 800)
    },
    confirmarPagamentoAction () {
      const confirma = confirm(`Confirmar pagamento para esta GRV?`)
      if (!confirma) return
      const convertMoneyToFloat = str => +str.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.')
      let pagamento = {...this.pagamamento}
      pagamento.valor = convertMoneyToFloat(pagamento.valor)
      pagamento.referenciaPagamento = this.referencia
      this.$loaderOverlay.open().message('Registrando pagamento')
      pagarPreretirada(this.preretirada.id, pagamento)
        .then((response) => {
          this.pagamentoProcessado = true
          this.$loaderOverlay.hide()
          let data = response.data
          console.log(response, data)
          this.$emit('statusPagamentoAlterado')
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    registrarChavePix () {
      if (!(this.chavePixPagador || '').trim()) {
        return alert('Informe a chave pix')
      }
      const confirma = confirm(`Confirmar registro da chave "${this.chavePixPagador}"?`)
      if (!confirma) return
      this.$loaderOverlay.open().message('Salvando chave pix, aguarde')
      registraChavePix(this.preretirada.id, this.chavePixPagador)
        .then((response) => {
          this.$loaderOverlay.hide()
          console.log(response.data)
          this.preretirada.chavePixPagador = response.data.chavePixPagador
        })
        .catch((response) => {
          alert('Falha ao registrar, tente novamente.')
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    StatusTitlePreRetirada (s, t) {
      return StatusTitlePreRetirada(s, t)
    },
    handleDataPagamentoAlterada (novaDataPagamento) {
      this.preretirada.dataPagamento = novaDataPagamento
    },
    handlePixAlterado (novoPix) {
      this.preretirada.chavePixPagador = novoPix
    },
    setStatusPendente () {
      const confirma = confirm('Voltar essa pré-retirada para pendente?')
      if (!confirma) return
      this.$loaderOverlay.open().message('Alterando status, aguarde')

      alteraStatusParaPendente(this.preretirada.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.$emit('statusPagamentoAlterado')
          this.preretirada.status = 0
        })
        .catch((response) => {
          alert('Falha ao registrar, tente novamente.')
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    async getPixStatus () {
      if (!this.txid) {
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Nenhum Pix encontrado para consulta.'
        return
      }

      try {
        this.$loaderOverlay.open()
        const response = await consultarPix(this.txid)
        const status = response.data.status
        this.statusPix = status

        if (status === this.STATUS_PIX_COBRANCA_CONCLUIDA) {
          this.descricaoPix = '<i class="fa fa-check-circle text-success"></i> Pix pago com sucesso.'
        } else if (status === this.STATUS_PIX_COBRANCA_ATIVA) {
          this.descricaoPix = '<i class="fa fa-refresh text-warning"></i> Pix ativo. Aguardando pagamento.'
        } else {
          this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Pix canceladd, expirada ou não encontrada.'
        }
      } catch (e) {
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Erro ao consultar status do Pix.'
        console.error(e)
      } finally {
        this.$loaderOverlay.hide()
      }
    }
  }
}
</script>

<template>
  <div class="wrapper">
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12">Retirada id #{{preretirada.id}} prevista para
          {{moment(preretirada.dataPrevista.date).format('L')}}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4">Pagador:</div>
        <div class="col-xs-8 font-bold">{{preretirada.nomePagador}}</div>
      </div>
      <div class="row">
        <div class="col-xs-4">Documento:</div>
        <div class="col-xs-8 font-bold">{{preretirada.documentoPagador}}</div>
      </div>
      <div class="row">
        <div class="col-xs-4">Valor:</div>
        <div class="col-xs-8 font-bold">R$ {{preretirada.valor|moeda}}</div>
      </div>
      <div class="row">
        <div class="col-xs-4">Referência:</div>
        <div class="col-xs-8 font-bold">{{preretirada.referencia}}</div>
      </div>
      <div class="row" v-if="preretirada.favorecido === FAVORECIDO_APL">
        <div class="col-xs-4">Pix pagador:</div>
        <div class="col-xs-8 font-bold">{{preretirada.chavePixPagador}}</div>
      </div>
      <div v-if="preretirada.status === STATUS_PENDENTE">
        <div class="row m-t">
          <form v-on:submit.prevent="consultar" class="bs-example form-horizontal form-grv" v-if="preretirada.favorecido === FAVORECIDO_DETRO">
            <div class="col-xs-6"><input v-model="referencia" placeholder="Digite o número de referência"
                                         class="form-control" type="text"/>
            </div>
            <div class="col-xs-6">
              <button type="submit" class="btn btn-info">Consultar</button>
            </div>
          </form>
          <form v-on:submit.prevent="registrarChavePix" class="bs-example form-horizontal form-grv" v-if="preretirada.favorecido === FAVORECIDO_APL">
            <div class="col-xs-6">
              <input v-model="chavePixPagador" placeholder="Insira a chave pix do pagador" class="form-control" type="text" required/>
            </div>
            <div class="col-xs-6">
              <button type="submit" class="btn btn-info">Salvar</button>
            </div>
          </form>
        </div>
        <div v-if="emitirRespostaConsultaBoleto">
          <div class="alert m-t" :class="consultaBoleto.pago ? 'alert-success' : 'alert-danger'">
            <div v-if="consultaBoleto.naoEncontrado">
              Registro de <strong>boleto não encontrado</strong>. Referência: {{consultaBoleto.referencia}}
            </div>
            <div v-else-if="consultaBoleto.pago">
              Boleto pago
            </div>
            <div v-else>
              Não pago
            </div>
          </div>
        </div>
        <div class="row m-t" v-if="!pagamentoProcessado && !pagamentoCancelado">
          <div class="col-xs-12">
            <div class="m-b">Ações</div>
            <div class="form-inline">
              <a @click="definirPago" class="btn btn-success"><i class="fa fa-check"></i> Definir como pago</a>
              <a @click="cancelar" class="btn btn-danger"><i class="fa fa-times"></i> Cancelar Pré-Retirada</a>
              <template v-if="preretirada.favorecido === FAVORECIDO_APL">
                <button class="btn btn-info" @click="getPixStatus">
                  Checar status PIX Pré-Retirada
                </button>
                <span v-if="descricaoPix" class="small align-middle" v-html="descricaoPix" style="margin-left: 10px;"></span>
              </template>
            </div>
            <div class="m-t" v-if="confirmarPagamento">
              <div class="row">
                <div class="col-sm-4"> Valor: </div>
                <div class="col-sm-4">
                  <input v-model="pagamamento.valor" placeholder="R$ 0,00" v-money="money" class="form-control" type="text" :disabled="!isAdministradorExclusivo"/>
                </div>
                <div class="col-sm-4">
                  <button @click="confirmarPagamentoAction" class="btn btn-success">Confirmar Pagamento</button>
                </div>
              </div>
              <div class="row m-t-xs">
                <div class="col-sm-4"> Data de pagamento: </div>
                <div class="col-sm-4">
                  <input v-model="pagamamento.dataPagamento" placeholder="dd/mm/yyyy" v-mask="'##/##/####'" class="form-control" type="text"/>
                </div>
                <div class="col-sm-4">
                </div>
              </div>

            </div>
            <div class="bg-warning lter b-b wrapper-md m-t " v-if="confirmarPagamento || alertaConfirmarCancelamento">
              <div class="row">
                <div class="col-xs-12">
                  <h1 class="font-thin h5 text-black">
                    <strong>Atenção</strong><br>
                    Confira os dados da GRV antes de confirmar essa ação
                  </h1>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="row m-t" v-else-if="pagamentoProcessado">
          <div class="col-xs-12">
            <strong>Pagamento processado com sucesso.</strong>
          </div>
        </div>
        <div class="row m-t" v-else>
          <div class="col-xs-12 text-danger">
            Pagamento cancelado.
          </div>
        </div>
      </div>
      <div v-else>
        Status da Retirada: <strong :class="'text-' + StatusPreRetirada[preretirada.status].class">{{StatusTitlePreRetirada(preretirada.status)}}</strong>
        <div class="row m-t" v-if="preretirada.status === STATUS_PAGO">
          <div class="col-xs-4">Data do Pagamento:</div>
          <div class="col-xs-8 font-bold">{{moment(preretirada.dataPagamento.date).format('L')}}</div>
        </div>
        <div class="row" v-if="preretirada.status === STATUS_PAGO">
          <div class="col-xs-4">Referência Informada:</div>
          <div class="col-xs-8 font-bold">{{preretirada.referenciaPagamento}}</div>
        </div>
        <div class="row" v-if="preretirada.status === STATUS_PAGO">
          <div class="col-xs-12">
            <a v-if="preretirada.status === STATUS_PENDENTE" :href="preretirada.urlBoleto"
               target="_blank"
               class="btn btn-xs btn-primary btn-block m-t-xs"
            >
              <i class="fa fa-barcode"></i> Ver boleto
            </a>
            <!-- <a class="btn btn-xs btn-primary btn-block m-t-xs">
                    <i class="fa fa-barcode"></i> Ver boleto
                 </a>-->
          </div>
        </div>
        <div style="display: flex;" v-if="isAdministradorExclusivo">
          <btn-altera-data-pagamento-preretirada
            :pre-retirada-id="preretirada.id"
            @dataAlterada="handleDataPagamentoAlterada"
          ></btn-altera-data-pagamento-preretirada>
          <btn-altera-pix-pagador
            class="m-l"
            v-if="preretirada.favorecido === FAVORECIDO_APL"
            :pre-retirada-id="preretirada.id"
            @pixAlterado="handlePixAlterado"
          ></btn-altera-pix-pagador>

          <div class="m-t-sm m-b-sm m-l">
            <a class="btn btn-default font-bold btn-dark" @click="setStatusPendente">Voltar pré-retirada para pendente</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ConsultaPagamento.vue?7dfdedb4